import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { FlexBetween, FlexCenter } from '../../../global/commonStyle';

const NavigationWrapper = styled.div`
  display: none;
  ${mobile_xl(css`
    padding: var(--space-20) var(--space-20);
    ${FlexBetween}
    position: fixed;
    gap: var(--space-12);
    left: 0;
    bottom: 0;
    z-index: var(--z-index-header);
    width: calc(100vw - 40px);
    isolation: isolate;

    /* glass effect css */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: var(--background-glass-effect);
      backdrop-filter: blur(4px);
      mask-image: var(--progressive-blur-2);
      -webkit-mask-image: var(--progressive-blur-2);
      pointer-events: none;
    }
    .left-gradient {
      background: var(--left-gradient-2);
      position: absolute;
      bottom: -9px;
      left: 0;
      height: 48px;
      width: 100vw;
      filter: blur(10px);
    }
    & > * {
      position: relative;
      z-index: var(--z-index-base);
    }
  `)}
`;

const NavigationItemWrapper = styled.div`
  ${FlexBetween}
  border-radius: var(--border-radius-full);
  overflow: hidden;
  padding: var(--space-4);
  position: relative;
  background: var(--glass-base-tint-2);
  box-shadow: var(--glass-drop-shadow-2);
  backdrop-filter: blur(14px);
`;

const NavigationItem = styled.div<{ disabled?: boolean }>`
  padding: var(--space-12);
  ${FlexCenter}
`;
export { NavigationWrapper, NavigationItem, NavigationItemWrapper };
